module.exports = __webpack_public_path__ + "media/images/logo-7e99a898.png";